<script>
import forminput from "../formcomponet/forminput.vue";
import formdate from "../formcomponet/formdate.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyafatura from "@/models/satdosyafatura";
export default {
  mixins: [apibtoast, apigeneric, satdosyafatura],
  props: ["satdosyaId", "Firmaid", "Tamamlandi","SatDosya"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormData: {},
      FormDataStrBirimButce: {},
      FormDataStrBirimButceUpdate: {},
      harcamagirisData: {}
    };
  },
  components: {
    Loader,
    forminput,
    formdate,
  },
  watch: {
    satdosyaId(){ this.Get(); },
    Firmaid(){ this.Get(); },
  },
  methods: {
    Get() {
      let Page = {
          PageNumber: "1",
          PageSize: "50",
            };
          this.ActionsFilterGet({ Service: "StrBirimButceHarcamalari", Page: Page, Filter: "&Satdosyaid=" + this.SatDosya.Id  }).then((res) => {
              this.harcamagirisData = res.Data[0];
          this.ActionsFilterGet({ Service: "StrBirimButceHarcamalariTutarlari", Page: Page, Filter: "&Birimbutceharcamalariid=" + this.harcamagirisData.Id + "&Firmaid=" + this.Firmaid  }).then((res) => {
            this.FormDataStrBirimButceUpdate = res.Data[0];
            
          });
          });
      this.ActionsFilterGet({
        Service: "satdosyafatura",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId +
          "&Dosyafirmaid=" + this.Firmaid,
      }).then((res) => {
        if (res.TotalCount > 0) {
          this.AddEdit = "Edit";
          this.FormData = res.Data[0];
          this.FormData.Birimid = this.SatDosya.Ihaleyiyapanmakam
        } else {
          this.AddEdit = "Add";
          this.FormData = this.satdosyafaturaData;
          this.FormData.Dosyaid = this.satdosyaId;
          this.FormData.Dosyafirmaid = this.Firmaid;
          this.FormData.Birimid = this.SatDosya.Ihaleyiyapanmakam
        }
      });
    },
    onSubmit() {
      this.FormDataStrBirimButce.Firmaid = this.Firmaid;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("satdosyafatura", this.FormData);
          this.$bvModal.hide("satdosyafatura");
          this.$emit("TableUpdate"); 

          this.FormDataStrBirimButce.Kdv = this.FormData.Kdvlifaturatutari - this.FormData.Faturatutari;  
          this.FormDataStrBirimButce.Kdvsiz = this.FormData.Faturatutari;

          this.FormDataStrBirimButce.Birimbutceharcamalariid = this.harcamagirisData.Id;
          this.FormDataStrBirimButce.Hesapkodlariid  = this.SatDosya.Hesapkodu;
          this.FormDataStrBirimButce.Iskalemadi = this.SatDosya.Baslik; 
          this.FormDataStrBirimButce.Tutar = parseFloat(this.FormData.Kdvlifaturatutari);
     //    this.Post("StrBirimButceHarcamalariTutarlari", this.FormDataStrBirimButce);
        } else {
          this.Update("satdosyafatura", this.FormData);
          this.$bvModal.hide("satdosyafatura");
          if(this.FormDataStrBirimButceUpdate != null){

            this.FormDataStrBirimButceUpdate.Kdv = parseFloat((this.FormData.Kdvlifaturatutari) - parseFloat(this.FormData.Faturatutari));  
          this.FormDataStrBirimButceUpdate.Kdvsiz = this.FormData.Faturatutari;
          this.FormDataStrBirimButceUpdate.Firmaid = this.Firmaid;
          this.FormDataStrBirimButceUpdate.Birimbutceharcamalariid = this.harcamagirisData.Id;
          this.FormDataStrBirimButceUpdate.Hesapkodlariid  = this.SatDosya.Hesapkodu;
          this.FormDataStrBirimButceUpdate.Iskalemadi = this.SatDosya.Baslik; 
          this.FormDataStrBirimButceUpdate.Tutar = parseFloat(this.FormData.Kdvlifaturatutari);
      //    this.Update("StrBirimButceHarcamalariTutarlari", this.FormDataStrBirimButceUpdate);
          this.$emit("TableUpdate"); 
          }else{
            this.FormDataStrBirimButce.Kdv = this.FormData.Kdvlifaturatutari - this.FormData.Faturatutari; 
          this.FormDataStrBirimButce.Kdvsiz = this.FormData.Faturatutari;
          this.FormDataStrBirimButce.Birimbutceharcamalariid = this.harcamagirisData.Id;
          this.FormDataStrBirimButce.Hesapkodlariid  = this.SatDosya.Hesapkodu;
          this.FormDataStrBirimButce.Iskalemadi = this.SatDosya.Baslik; 
          this.FormDataStrBirimButce.Tutar = parseFloat(this.FormData.Kdvlifaturatutari);
       /*   this.Post("StrBirimButceHarcamalariTutarlari", this.FormDataStrBirimButce).then((res) => {
            if(res.Succeeded == true){
              this.FormDataStrBirimButce = {}; 
            }

            
          });*/
          this.$emit("TableUpdate"); 
          }

        }
      }
    },
  },
};
</script>
<template>
  <Loader> 
    <b-modal id="satdosyafatura" size="lg" :title="
      this.AddEdit == 'Edit'
        ? $t('satdosyafatura.AddEdit.FormTitleEdit')
        : $t('satdosyafatura.AddEdit.FormTitleAdd')
    " title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-6">
            <formdate :FormDataType="FormDataType.Faturatarihi" :Value="FormData.Faturatarihi"
              :v="$v.FormData.Faturatarihi" @input="FormData.Faturatarihi = $event" />
          </div>
          <div class="col-md-6">
            <forminput :FormDataType="FormDataType.Faturanumarasi" :Value="FormData.Faturanumarasi"
              :v="$v.FormData.Faturanumarasi" @input="FormData.Faturanumarasi = $event" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <forminput :FormDataType="FormDataType.Faturatutari" :Value="FormData.Faturatutari"
              :v="$v.FormData.Faturatutari" @input="FormData.Faturatutari = $event"  :min="0"
              :step="0.0001"/>
          </div>
          <div class="col-md-6">
            <forminput :FormDataType="FormDataType.Kdvlifaturatutari" :Value="FormData.Kdvlifaturatutari"
              :v="$v.FormData.Kdvlifaturatutari" @input="FormData.Kdvlifaturatutari = $event"  :min="0"
              :step="0.0001"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <forminput :FormDataType="FormDataType.Onaytarihvenumarasi" :Value="FormData.Onaytarihvenumarasi"
              :v="$v.FormData.Onaytarihvenumarasi" @input="FormData.Onaytarihvenumarasi = $event" />
          </div>
        </div>
        <button class="btn btn-primary" type="submit" v-if="!Tamamlandi">
          {{ $t("satdosyafatura.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
